import util from "../util";

let controller = "TemposPix";
export default Object.assign({}, {
    ExportarRelatorioTempos: function (dto) {
      return util.Axios.Post(controller + '/gerar-relatorio-apix', dto)
    }
  })